import CashbackRates from './CashbackRates';

export default CashbackRates;
